export default __webpack_public_path__ + "static/media/others-review-img.ae5bd4e2.svg";